import { type ZonedDateTime, now, getLocalTimeZone } from '@internationalized/date';
import type { Action, Field, Form } from '@jmvdevelop/svelte-form';
import { addFieldOrRootError } from '$lib/validator/validatorUtils.js';

export function futureZonedDateTime<TValues>(
    value: ZonedDateTime | undefined | null,
    {
        form,
        field,
        message,
        futureValue = null,
    }: {
        form: Form<TValues, string>;
        field?: Field<TValues, ZonedDateTime | null>;
        message: string;
        futureValue?: ZonedDateTime | null;
    },
): Action<TValues, string> {
    if (futureValue == null) futureValue = now(getLocalTimeZone());
    if (value != null && futureValue.compare(value) > 0) {
        return addFieldOrRootError(form, field, message);
    }
    return (s) => s;
}
